const toc = document.getElementById("table-of-contents")
Get_H2_Labels()

function Get_H2_Labels(){
    toc.removeChild(toc.firstChild)

    let ulist = document.createElement("ul")
    toc.appendChild(ulist)

    let headers = document.querySelectorAll("main .shopify-section:not(.cc-featured-blog) h2")

    headers.forEach((header)=>{
        let closest_id = header.closest("[id]")
        if (closest_id != undefined && !header.classList.contains("skip-toc")){
            let link = document.createElement("a")
            
            
            link.href = `#${closest_id.id}`
            link.classList.add("toc-item")
            link.textContent = header.textContent

            let list_item = document.createElement("li")
            list_item.appendChild(link)
            ulist.appendChild(list_item)
        }


    })

}